import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { isNull } from "lodash";
import { endOfWeek, startOfWeek } from "date-fns";
import moment from "moment";
import { useAuthContext } from "../../sections/auth/useAuthContext";
import { DEFAULT_USER_TIMEZONE } from "../../utils/dateTimezone";

export const ScheduleProviderContext = createContext(null);

export const ScheduleProviderProvider = ({ children }) => {
  const { user } = useAuthContext();
  const [scheduleScreenTimezone, setScheduleScreenTimezone] = useState(
    () => user?.userTimezone || DEFAULT_USER_TIMEZONE
  );

  const [openUpserModal, setOpenUpserModal] = useState(false);
  const [openShiftRepeatModal, setOpenShiftRepeatModal] = useState(false);
  const [openApplyShiftTemplate, setOpenApplyShiftTemplate] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [shiftTempSchedRecord, setShiftTempSchedRecord] = useState();
  const [selectedDate, setSelectedDate] = useState(moment(new Date()));
  const [selectedSched, setSelectedSched] = useState(() => new Set());
  const [action, setAction] = useState("");
  const [selectedSchedIds, setSelectedSchedIds] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [schedulesList, setSchedulesList] = useState([]);
  const [schedulesRaw, setSchedulesRaw] = useState([]);
  const [isUndoRedo, setisUndoRedo] = useState(false);
  const [scheduleFilters, setScheduleFilters] = useState([]);
  const [upsertErrors, setUpsertErrors] = useState();
  const [upsertShowModal, setUpsertShowModal] = useState(false);

  const [selectedTime, setSelectedTime] = useState({
    timeBreak: moment().startOf("day"),
    timeStart: moment(new Date()).minutes(0),
    timeEnd: moment(new Date()).minutes(0),
    totalWorkHours: "0 hrs 0 min",
    breaks: [],
    timeDetailsJson: {},
  });
  const [selectedCustomerSiteService, setSelectedCustomerSiteService] =
    useState({
      customer: "",
      site: "",
      services: "",
    });
  const [selectedRecord, setSelectedRecord] = useState();

  // const [week, setWeek] = useState({
  //   firstDay: startOfWeek(new Date(), { weekStartsOn: 0 }),
  //   lastDay: endOfWeek(new Date(), { weekStartsOn: 6 }),
  // });

  const [week, setWeek] = useState([null, null]);

  useEffect(() => {
    if (user?.userTimezone) {
      setScheduleScreenTimezone(user.userTimezone);
    }
  }, [user?.userTimezone]);

  const memoizedValue = useMemo(
    () => ({
      openUpserModal,
      setOpenUpserModal,
      shiftTempSchedRecord,
      setShiftTempSchedRecord,
      week,
      setWeek,
      selectedDate,
      setSelectedDate,
      selectedRecord,
      setSelectedRecord,
      selectedTime,
      setSelectedTime,
      selectedCustomerSiteService,
      setSelectedCustomerSiteService,
      selectedSched,
      setSelectedSched,
      openShiftRepeatModal,
      setOpenShiftRepeatModal,
      action,
      setAction,
      selectedSchedIds,
      setSelectedSchedIds,
      openApplyShiftTemplate,
      setOpenApplyShiftTemplate,
      draftData,
      setDraftData,
      schedulesList,
      setSchedulesList,
      schedulesRaw,
      setSchedulesRaw,
      isUndoRedo,
      setisUndoRedo,
      openFilterModal,
      setOpenFilterModal,
      scheduleFilters,
      setScheduleFilters,
      upsertErrors,
      setUpsertErrors,
      upsertShowModal,
      setUpsertShowModal,
      scheduleScreenTimezone,
      setScheduleScreenTimezone,
    }),
    [
      openUpserModal,
      shiftTempSchedRecord,
      week,
      selectedDate,
      selectedRecord,
      selectedTime,
      selectedCustomerSiteService,
      selectedSched,
      openShiftRepeatModal,
      action,
      selectedSchedIds,
      openApplyShiftTemplate,
      draftData,
      schedulesList,
      schedulesRaw,
      isUndoRedo,
      openFilterModal,
      scheduleFilters,
      upsertErrors,
      upsertShowModal,
      scheduleScreenTimezone,
    ]
  );

  return (
    <ScheduleProviderContext.Provider value={memoizedValue}>
      {children}
    </ScheduleProviderContext.Provider>
  );
};

export const useScheduleProviderContext = () => {
  const context = useContext(ScheduleProviderContext);

  if (!context)
    throw new Error(
      "useScheduleProviderContext context must be use inside ScheduleProviderProvider"
    );

  return context;
};

ScheduleProviderProvider.propTypes = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------